import { render, staticRenderFns } from "./money.vue?vue&type=template&id=1395d7d4&"
import script from "./money.vue?vue&type=script&lang=ts&"
export * from "./money.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports